import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import './blog-detail.scss';

const timingsData = [
  {
    id: 1,
    title: 'Morning Darshan',
    time: '05:00 AM - 01:30 PM',
    highlight: false,
    timeColor: 'teal',
  },
  {
    id: 2,
    title: 'Temple Cleansing & Rest',
    time: '01:30 PM - 05:00 PM',
    highlight: false,
    timeColor: 'dark',
  },
  {
    id: 3,
    title: 'Evening Aarti (Sandhya)',
    time: '06:00 PM - 07:30 PM',
    highlight: true,
    timeColor: 'gold',
  },
  {
    id: 4,
    title: 'Shayan Aarti',
    time: '08:30 PM',
    highlight: false,
    timeColor: 'teal',
  },
  {
    id: 5,
    title: 'Temple Closing Time',
    time: '09:00 PM',
    highlight: false,
    timeColor: 'dark',
  },
];

const dossierData = [
  { key: 'Location & District', val: 'Rudraprayag, Uttarakhand, India' },
  { key: 'Altitude / Elevation', val: '3,584 m (approx. 11,759 ft)' },
  { key: 'Presiding Deity', val: 'Lord Shiva (Sadashiva - 11th Jyotirlinga)' },
  { key: 'Sacred River', val: 'Mandakini River' },
  { key: 'Trek Route', val: '16 km trek from Gaurikund' },
  { key: 'Pilgrimage Window', val: 'Akshaya Tritiya (May) to Bhai Dooj (Nov)' },
  { key: 'Panch Kedar Part', val: 'Hump of the Divine Bull (Prishta)' },
];

const panchKedarList = [
  {
    id: 1,
    name: '1. Kedarnath Temple',
    tag: 'Hump (Back of Lord Shiva)',
    image: '/assets/blog/stories/kedarnath-shivling.webp',
  },
  {
    id: 2,
    name: '2. Tungnath Temple',
    tag: 'Divine Arms (Bhuja)',
    image: '/assets/trending/kedarnath.webp',
  },
  {
    id: 3,
    name: '3. Rudranath Temple',
    tag: 'Sacred Face (Mukha)',
    image: '/assets/blog/trending/kedarnath.webp',
  },
  {
    id: 4,
    name: '4. Madhyamaheshwar',
    tag: 'Navel & Torso (Nabhi)',
    image: '/assets/blog/stories/kedarnath-shivling.webp',
  },
  {
    id: 5,
    name: '5. Kalpeshwar Temple',
    tag: 'Matted Hair (Jata)',
    image: '/assets/trending/kedarnath.webp',
  },
];

const interestedBlogs = [
  {
    id: 1,
    title: 'पितृपक्ष में कौए को भोजन क्यों खिलाया जाता है? जानिए पौराणिक कथा और श्राद्ध पूजा विधि',
    image: '/assets/blog/pitru-paksha-crow-banner.jpg',
    link: '/blog/pitru-paksha-crow-significance-shradh-puja-vidhi',
  },
  {
    id: 2,
    title: 'Anant Chaturdashi 2026: Date, Ganesh Visarjan, Puja & Significance',
    image: '/assets/blog/ganesh-chaturthi-banner.webp',
    link: '/blog/anant-chaturdashi-ganesh-visarjan',
  },
  {
    id: 3,
    title: 'माता वैष्णो देवी की संपूर्ण कथा: भक्त श्रीधर और भैरवनाथ',
    image: '/assets/trending/vaishno-devi.webp',
    link: '/blog/vaishno-devi-story-shridhar-bhairavnath',
  },
];

export default function KedarnathBlogDetail() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.title =
      'केदारनाथ मंदिर: जहाँ धरती में समा गए थे भगवान शिव! जानिए मंदिर का इतिहास और पांडवों से जुड़ी प्राचीन कथा | MandirWiki';
  }, [location.pathname]);

  return (
    <div className="blog-detail-page">
      {/* ========================================================
          1. HERO BANNER
      ======================================================== */}
      <section
        className="blog-detail-banner kedarnath-hero-banner"
        style={{
          backgroundImage: "url('/assets/home/kedarnath-mystery-bg.jpg')",
          backgroundPosition: 'center center',
        }}
      >
        <Container maxWidth="lg" className="banner-container">
          <Box className="banner-content" sx={{ maxWidth: { xs: '100%', md: '640px' } }}>
            <h1 className="banner-title" style={{ fontSize: 'clamp(24px, 2.7vw, 36px)', lineHeight: 1.35 }}>
              केदारनाथ मंदिर: <br />
              जहाँ धरती में समा गए थे भगवान शिव! <br />
              <span style={{ fontSize: '0.85em', fontWeight: 600, opacity: 0.95 }}>
                जानिए मंदिर का इतिहास और पांडवों से जुड़ी प्राचीन कथा
              </span>
            </h1>
          </Box>
        </Container>
      </section>

      {/* ========================================================
          2. MAIN CONTENT & SIDEBAR SECTION
      ======================================================== */}
      <section className="blog-body-section">
        <Container maxWidth="lg">
          <div className="blog-body-inner">
            {/* Breadcrumbs */}
            <nav className="blog-breadcrumbs" aria-label="breadcrumb">
              <Link to="/" className="breadcrumb-link">
                Home
              </Link>
              <span className="breadcrumb-separator">&gt;</span>
              <Link to="/blog" className="breadcrumb-link">
                Blog
              </Link>
              <span className="breadcrumb-separator">&gt;</span>
              <span className="breadcrumb-current">
                केदारनाथ मंदिर का इतिहास और पौराणिक कथा
              </span>
            </nav>

            {/* Two Column Grid */}
            <div className="blog-main-layout">
              {/* Left Column: Article Body */}
              <article className="blog-article-content">
                <p className="article-paragraph">
                  भारतीय संस्कृति में तीर्थ यात्रा को बहुत ही पुण्य कार्य माना गया है। यही वजह है कि भक्त अपने जीवन काल में किसी न किसी तीर्थ स्थल पर जाकर भगवान के दर्शन अवश्य करना चाहते हैं। भारत में ऐसे अनेक पवित्र तीर्थ हैं, जहाँ हर दिन श्रद्धालुओं की भीड़ देखने को मिलती है।
                </p>

                <p className="article-paragraph">
                  लेकिन हिमालय की ऊंची पहाड़ियों के बीच बसा भगवान शिव का केदारनाथ धाम इन सभी तीर्थों में अपनी एक अलग पहचान रखता है। बर्फ से ढकी चोटियों और शांत प्राकृतिक वातावरण के बीच स्थित यह प्राचीन मंदिर करोड़ों श्रद्धालुओं की आस्था का केंद्र है।
                </p>

                <p className="article-paragraph">
                  केदारनाथ मंदिर भगवान शिव के 12 ज्योतिर्लिंगों में से एक माना जाता है। इस धाम से जुड़ी पौराणिक कथा भी बहुत ही रोचक है। मान्यता के अनुसार महाभारत के युद्ध के बाद पांडव भगवान शिव की तलाश में इसी स्थान पर पहुंचे थे। किंतु पांडवों से बचने के लिए भगवान शिव ने बैल का रूप धारण कर लिया और धरती में समाने लगे। आखिर ऐसी कौन सी वजह थी, जिस कारण भगवान शिव पांडवों से मिलना नहीं चाहते थे, और उन्हें ऐसी लीला रचनी पड़ी? भगवान शिव के शरीर का कौन सा हिस्सा केदारनाथ में रह गया, और इस स्थान का संबंध पंच केदार से कैसे जुड़ा? आइए जानते हैं केदारनाथ मंदिर का इतिहास और भगवान शिव से जुड़ी इस पवित्र धाम की पौराणिक कथा का रहस्य।
                </p>

                <h2 className="article-heading">
                  केदारनाथ मंदिर कहाँ स्थित है और इसका इतिहास कितना पुराना है?
                </h2>

                {/* Inline Media Row: Kedarnath Temple Image + Text */}
                <div className="article-media-row">
                  <div className="media-image-box">
                    <img
                      src="/assets/blog/trending/kedarnath.webp"
                      alt="केदारनाथ मंदिर, उत्तराखंड"
                      className="media-image"
                      loading="lazy"
                    />
                  </div>
                  <div className="media-text-box">
                    <p className="article-paragraph">
                      केदारनाथ मंदिर उत्तराखंड के रुद्रप्रयाग जिले में हिमालय की ऊंची पर्वत श्रृंखलाओं के बीच स्थित है। चारों ओर बर्फ से ढके पहाड़ और शांत प्राकृतिक वातावरण इस पवित्र धाम की सुंदरता को और बढ़ा देते हैं।
                    </p>
                    <p className="article-paragraph">
                      केदारनाथ मंदिर तक पहुंचना अपने आप में एक कठिन यात्रा मानी जाती है, क्योंकि यह स्थान समुद्र तल से करीब 3,584 मीटर की ऊंचाई पर स्थित है। गौरीकुंड से पहाड़ी रास्ते के द्वारा मंदिर तक पहुंचने का मार्ग है। रास्ते भर भोलेनाथ भगवान शिव के नाम का जयकारा लगाते, और बाबा केदारनाथ की महिमा का गुणगान करते हुए श्रद्धालु पूरी आस्था और विश्वास के साथ केदारनाथ धाम पहुंचते हैं।
                    </p>
                  </div>
                </div>

                <p className="article-paragraph">
                  केदारनाथ मंदिर के इतिहास की बात करें तो इससे जुड़ी कई धार्मिक और पौराणिक मान्यताएं प्रचलित हैं। “मान्यता के अनुसार पांडवों का इस स्थान से संबंध रहा है; कहा जाता है, कि उन्होंने यहाँ भगवान शिव की पूजा की थी” वहीं केदारनाथ की धार्मिक परंपरा को आदि शंकराचार्य से भी जोड़ा जाता है। मंदिर के पास आदि शंकराचार्य की समाधि भी मानी जाती है।
                </p>

                <p className="article-paragraph">
                  हालांकि मंदिर के निर्माण और इसके प्राचीन इतिहास को लेकर अलग-अलग मत मिलते हैं। इसलिए पांडवों से जुड़े प्रसंगों को पौराणिक मान्यता के रूप में ही देखा जाता है।
                </p>

                {/* Section 2 */}
                <h2 className="article-heading">
                  महाभारत के बाद पांडव क्यों पहुंचे भगवान शिव की शरण में?
                </h2>

                <p className="article-paragraph">
                  महाभारत का युद्ध समाप्त हो चुका था। पांडवों को युद्ध में विजय तो मिल गई थी, लेकिन इस युद्ध में उनके अपने ही परिवार के अनेक लोगों की मृत्यु हुई थी। इस कारण उनके मन में गहरा पश्चाताप था।
                </p>

                <p className="article-paragraph">
                  पौराणिक मान्यता के अनुसार पांडव भगवान शिव की शरण में जाकर उनसे क्षमा मांगना चाहते थे। वह भगवान शिव का आशीर्वाद प्राप्त करके अपने मन के बोझ से मुक्ति पाना चाहते थे।
                </p>

                <p className="article-paragraph">
                  लेकिन भगवान शिव पांडवों को आसानी से दर्शन नहीं दे रहे थे। मान्यता है कि वह पांडवों से छिपते हुए हिमालय की ओर चले गए। पांडव भी भगवान शिव की तलाश करते हुए हिमालय पहुंच गए।
                </p>

                <p className="article-paragraph">
                  कहा जाता है कि पांडवों को आता देखकर भगवान शिव ने स्वयं को उनसे छुपाने के लिए बैल का रूप धारण कर लिया और दूसरे पशुओं के झुंड में जा मिले।
                </p>

                <p className="article-paragraph">
                  पांडवों को जब उस झुंड में भगवान शिव के होने का आभास हुआ, तो उन्होंने पशुओं को ध्यान से देखना शुरू किया। उन्हें एक बैल कुछ अलग दिखाई दिया। वे समझ गए कि यही भगवान शिव हो सकते हैं।
                </p>

                <p className="article-paragraph">
                  भीम ने उस बैल को पकड़ने का प्रयास किया लेकिन तभी बैल धरती के भीतर समाने लगा।
                </p>
              </article>

              {/* Right Column: Sidebar Cards (Sticky) */}
              <aside className="blog-sidebar">
                {/* Card 1: Temple Timings */}
                <div className="muhurat-widget-card">
                  <div className="muhurat-header">
                    <div className="muhurat-header-title">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="clock-icon"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                      <span>Darshan &amp; Aarti Timings</span>
                    </div>

                    <span className="muhurat-pill-badge">
                      <span className="dot" />
                      11th Jyotirlinga &bull; Holy Dham
                    </span>
                  </div>

                  <div className="muhurat-body">
                    <div className="visarjan-day-meta">
                      Pilgrimage Season: <strong>May to November (Akshaya Tritiya - Bhai Dooj)</strong>
                    </div>

                    <div className="timings-list">
                      {timingsData.map((item) => (
                        <div
                          key={item.id}
                          className={`timing-row ${item.highlight ? 'highlight-gold' : ''}`}
                        >
                          <span className="timing-label">{item.title}</span>
                          <span className={`timing-val color-${item.timeColor}`}>
                            {item.time}
                          </span>
                        </div>
                      ))}
                    </div>

                    <Link to="/contact-us" style={{ textDecoration: 'none' }}>
                      <button type="button" className="book-puja-btn">
                        BOOK PUJA &amp; DARSHAN SEVA
                      </button>
                    </Link>

                    <p className="instant-booking-note">
                      Instant booking with certified Vedic Pandits
                    </p>
                  </div>
                </div>

                {/* Card 2: Kedarnath Dossier */}
                <div className="sidebar-card dossier-card">
                  <div className="sidebar-card-header">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="header-icon"
                    >
                      <path d="M3 21h18M3 10h18M5 10v11M19 10v11M9 10v11M15 10v11M12 2l10 8H2l10-8z" />
                    </svg>
                    <h3 className="card-title">Kedarnath Dham Quick Dossier</h3>
                  </div>

                  <div className="dossier-table">
                    {dossierData.map((row, idx) => (
                      <div key={idx} className="dossier-row">
                        <span className="dossier-key">{row.key}</span>
                        <span className="dossier-val">{row.val}</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Card 3: Panch Kedar Shrines */}
                <div className="sidebar-card ghats-card">
                  <div className="sidebar-card-header">
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="header-icon"
                    >
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                      <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>
                    <h3 className="card-title">Sacred Panch Kedar Shrines</h3>
                  </div>

                  <div className="ghats-list">
                    {panchKedarList.map((item) => (
                      <div key={item.id} className="ghat-item">
                        <img src={item.image} alt={item.name} className="ghat-thumb" />
                        <div className="ghat-info">
                          <h4 className="ghat-name">{item.name}</h4>
                          <span className="ghat-tag">{item.tag}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Card 4: Free Yatra Guide PDF */}
                <div className="sidebar-card pdf-card">
                  <div className="sidebar-card-header">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="header-icon"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <path d="M8 12l4 4 4-4m-4-4v8" />
                    </svg>
                    <h3 className="card-title">Free Offline Yatra Guide (PDF)</h3>
                  </div>

                  <p className="pdf-desc">
                    Comprehensive pilgrimage handbook covering the Gaurikund trek route, registration rules, weather advisory, and sacred rituals.
                  </p>

                  <a
                    href="/assets/startup-india-certificate.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none' }}
                  >
                    <button type="button" className="download-pdf-btn">
                      DOWNLOAD YATRA GUIDE (PDF)
                    </button>
                  </a>
                </div>
              </aside>
            </div>

            {/* ========================================================
                3. FULL GRID SECTION (Full Container Width Content)
            ======================================================== */}
            <div className="blog-full-grid-section">
              <div className="article-full-banner">
                <img
                  src="/assets/temple-images/kedarnath-temple/aarti1.jpg"
                  alt="भगवान शिव और केदारनाथ की पौराणिक कथा"
                  className="full-banner-img"
                  loading="lazy"
                />
              </div>

              <div className="full-grid-content">
                <h2 className="article-heading">
                  जब पांडवों से बचने के लिए धरती में समाने लगे भगवान शिव
                </h2>

                <p className="article-paragraph">
                  कथा के अनुसार भगवान शिव बैल के रूप में धरती में समाने लगे। भीम ने उन्हें रोकने की कोशिश की और बैल की पीठ को पकड़ लिया।
                </p>

                <p className="article-paragraph">
                  मान्यता है कि भगवान शिव के बैल रूप का कूबड़ (पीठ का भाग) वाला हिस्सा केदारनाथ में रह गया। इसी स्वरूप को यहां भगवान शिव के रूप में पूजा जाता है।
                </p>

                <p className="article-paragraph">
                  पांडवों की भक्ति और पश्चाताप देखकर भगवान शिव प्रसन्न हुए, और उन्होंने पांडवों को दर्शन दिए और आशीर्वाद प्रदान किया।
                </p>

                <p className="article-paragraph">
                  यही कथा केदारनाथ को पांडवों और भगवान शिव के संबंध से जोड़ती है।
                </p>

                <h2 className="article-heading">
                  भगवान शिव के पांच अंगों से कैसे जुड़े पंच केदार?
                </h2>

                {/* Media Row with Panch Kedar Shivling Image */}
                <div className="article-media-row vyasa-media-row">
                  <div className="media-image-box">
                    <img
                      src="/assets/blog/stories/kedarnath-shivling.webp"
                      alt="केदारनाथ स्वयंभू शिवलिंग एवं पंच केदार"
                      className="media-image"
                      loading="lazy"
                    />
                  </div>

                  <div className="media-text-box">
                    <p className="article-paragraph">
                      भगवान शिव के बैल रूप से जुड़ी कथा पंच केदार की मान्यता से भी जुड़ी हुई है।
                    </p>

                    <p className="article-paragraph">
                      मान्यता के अनुसार भगवान शिव के बैल रूप के अलग-अलग अंग पांच स्थानों पर प्रकट हुए। इन्हीं पांच पवित्र स्थानों को <strong>पंच केदार</strong> कहा जाता है:
                    </p>

                    <ul style={{ paddingLeft: '20px', color: '#374151', fontSize: '14.8px', lineHeight: 1.8 }}>
                      <li><strong>केदारनाथ:</strong> भगवान शिव का कूबड़ (पीठ भाग)</li>
                      <li><strong>तुंगनाथ:</strong> उनकी भुजाएं</li>
                      <li><strong>रुद्रनाथ:</strong> उनका मुख</li>
                      <li><strong>मध्यमहेश्वर:</strong> नाभि एवं मध्य भाग</li>
                      <li><strong>कल्पेश्वर:</strong> उनकी दिव्य जटाएं</li>
                    </ul>

                    <p className="article-paragraph" style={{ marginTop: '14px' }}>
                      इस तरह केदारनाथ के साथ चार अन्य पवित्र स्थान भी भगवान शिव की इसी पौराणिक कथा से जुड़े माने जाते हैं।
                    </p>
                  </div>
                </div>

                <h2 className="article-heading">
                  केदारनाथ धाम की विशेषता – 2013 की भयंकर आपदा में कैसे सुरक्षित रहा केदारनाथ मंदिर?
                </h2>

                {/* Full Banner: 2013 Disaster survival & Kedarnath presence */}
                <div className="article-full-banner">
                  <img
                    src="/assets/temple-images/kedarnath-temple/aarti2.jpg"
                    alt="केदारनाथ मंदिर एवं हिमालय पर्वतमाला - 2013 आपदा में सुरक्षित रहा पावन धाम"
                    className="full-banner-img"
                    loading="lazy"
                  />
                </div>

                <p className="article-paragraph">
                  हिंदू धार्मिक परंपरा में ज्योतिर्लिंग भगवान शिव के दिव्य स्वरूप से जुड़े माने जाते हैं। केदारनाथ धाम भगवान शिव के 12 ज्योतिर्लिंगों में से एक माना गया है।
                </p>

                <p className="article-paragraph">
                  वर्ष 2013 में केदारनाथ क्षेत्र में आई विनाशकारी बाढ़ और मलबे से भारी तबाही हुई। मंदिर के कुछ हिस्सों को नुकसान पहुंचा, लेकिन मंदिर की मुख्य संरचना सुरक्षित रही। भक्तों को विश्वास है, कि आज भी भगवान शिव केदारनाथ मंदिर में वास करते हैं और सदैव मंदिर की सुरक्षा करते रहते हैं।
                </p>

                {/* Conclusion */}
                <div className="article-conclusion-section">
                  <h2 className="article-heading">
                    निष्कर्ष: आस्था, साधना और शिव कृपा का पावन केंद्र
                  </h2>

                  <p className="article-paragraph">
                    केदारनाथ केवल एक मंदिर नहीं, बल्कि करोड़ों सनातन श्रद्धालुओं के अटूट विश्वास का प्रमाण है। समुद्र तल से 3,584 मीटर की ऊंचाई पर बर्फ से ढकी पर्वत श्रृंखलाओं में स्थित यह पवित्र धाम सदियों से भक्तों को शिव भक्ति, आंतरिक शांति और समर्पण का संदेश देता आ रहा है। पांडवों के पश्चाताप से लेकर आज तक, बाबा केदारनाथ अपने हर भक्त का कल्याण करते हैं।
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>

      {/* ========================================================
          4. YOU MIGHT ALSO BE INTERESTED IN THIS
      ======================================================== */}
      <section className="blog-interested-section pt-0">
        <Container maxWidth="lg">
          <h2 className="interested-heading">
            You Might Also Be Interested In This
          </h2>
          <div className="interested-grid">
            {interestedBlogs.map((item) => (
              <Link
                key={item.id}
                to={item.link}
                className="interested-card"
              >
                <div className="card-thumb-wrap">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="card-thumb"
                    loading="lazy"
                  />
                </div>
                <div className="card-content">
                  <h3 className="card-title">{item.title}</h3>
                </div>
              </Link>
            ))}
          </div>
        </Container>
      </section>
    </div>
  );
}
